import { IMG_KPO, KPO_DESCRIPTION } from './competitionBranding';

export const PublicFooter = () => (
  <footer className="w-full bg-white">
    <div className="mx-auto flex max-w-4xl flex-col items-center gap-5 px-6 py-8 text-center">
      <p className="max-w-3xl text-xs leading-relaxed text-gray-500">{KPO_DESCRIPTION}</p>
      <div className="flex flex-wrap items-center justify-center gap-8">
        <img src={IMG_KPO} alt="Logo KPO" className="h-10 object-contain" />
      </div>
    </div>
  </footer>
);
